<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>پیگیری سفارش‌ها</h6>
      </template>

      <br />
      <div>
        <b-tabs pills card vertical content-class="mr-3">
          <b-tab
            :title="'همه سفارش‌های فعال' + ' (' + items.length + ')'"
            active
          >
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                class="darkGreen-mainBtn float-start mb-4"
                style="width: 135px; height: 35px"
                :class="items.length ? 'white--text' : 'disabled-excel'"
                :data="items"
                :columns="
                  fields
                    .map((y) => {
                      return {
                        label: y.label,
                        field: y.key,
                      };
                    })
                    .filter((x) => x.field != 'index')
                    .filter((x) => x.field != 'operation')
                "
                :file-name="
                  'سفارشات_' +
                  moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
                "
                :sheet-name="'سفارشات'"
              >
                <v-icon :class="items.length ? 'white--text' : ''" class="me-1">
                  mdi-file-excel-outline
                </v-icon>
                خروجی اکسل</vue-excel-xlsx
              >

              <v-btn
                :disabled="
                  gettingReceipt || !computedOrders(items, 'allOrders').length
                "
                class="darkRed-mainBtn white--text mb-4 float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt('allOrders', 'همه‌ی درخواست‌های فعال')"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >

              <b-table
                responsive
                show-empty
                :items="computedOrders(items, 'allOrders')"
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="currentPage = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'index'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="
                        toFilterData['allOrders'] = [];
                        currentPage = 1;
                      "
                      >بازنشانی
                    </b-button>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>
                <template v-slot:cell(code)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a :href="'/factory/order/' + data.item.id" target="_blank">
                      {{ data.value }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(progress)="data">
                  <v-progress-circular
                    :rotate="270"
                    :size="40"
                    :width="3"
                    :value="data.item.progress"
                    color="teal"
                  >
                    {{ data.item.progress }}%
                  </v-progress-circular>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="btn btn-primary mr-1 mt-1"
                      :href="'/factory/order/' + data.item.id"
                      target="_blank"
                      role="button"
                      >جزییات</a
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>

              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="computedOrders(items, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
            </b-card>
          </b-tab>
          <b-tab
            v-for="status in statusOptions"
            :key="status.value"
            :title="
              status.text +
              ' (' +
              items
                .filter((x) => x.code != '-')
                .filter((x) => x.factoryStatus == status.value).length +
              ')'
            "
          >
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                class="darkGreen-mainBtn mb-4 float-start"
                style="width: 135px; height: 35px; float: right"
                :class="
                  computedOrders(
                    items
                      .filter((x) => x.code != '-')
                      .filter((x) => x.factoryStatus == status.value),
                    'allOrders'
                  ).length
                    ? 'white--text'
                    : 'disabled-excel'
                "
                :data="
                  computedOrders(
                    items
                      .filter((x) => x.code != '-')
                      .filter((x) => x.factoryStatus == status.value),
                    'allOrders'
                  )
                "
                :columns="ExcelFields"
                :file-name="status.value"
                :sheet-name="status.value"
              >
                <v-icon
                  class="me-1"
                  :class="
                    computedOrders(
                      items
                        .filter((x) => x.code != '-')
                        .filter((x) => x.factoryStatus == status.value),
                      'allOrders'
                    ).length
                      ? 'white--text'
                      : ''
                  "
                >
                  mdi-file-excel-outline </v-icon
                >خروجی اکسل
              </vue-excel-xlsx>

              <v-btn
                :disabled="
                  gettingReceipt ||
                  !computedOrders(
                    items
                      .filter((x) => x.code != '-')
                      .filter((x) => x.factoryStatus == status.value),
                    'allOrders'
                  ).length
                "
                class="darkRed-mainBtn white--text mb-4 float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt('tabs', status.value)"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >

              <b-table
                responsive
                show-empty
                :items="
                  computedOrders(
                    items
                      .filter((x) => x.code != '-')
                      .filter((x) => x.factoryStatus == status.value),
                    'allOrders'
                  )
                "
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :busy="isBusy"
                :current-page="currentPageNewOrder"
                :per-page="perPage"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="currentPageNewOrder = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'index'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="toFilterData['allOrders'] = []"
                      currentPageNewOrder="1;"
                      >بازنشانی
                    </b-button>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPageNewOrder - 1) }}
                  </div>
                </template>
                <template v-slot:cell(code)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a :href="'/factory/order/' + data.item.id" target="_blank">
                      {{ data.value }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(progress)="data">
                  <v-progress-circular
                    :rotate="270"
                    :size="40"
                    :width="3"
                    :value="data.item.progress"
                    color="teal"
                  >
                    {{ data.item.progress }}%
                  </v-progress-circular>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="btn btn-primary mr-1 mt-1"
                      :href="'/factory/order/' + data.item.id"
                      target="_blank"
                      role="button"
                      >جزییات</a
                    >
                    <b-btn
                      variant="warning"
                      class="mr-1 mt-1"
                      v-if="data.item.status != 'آرشیو'"
                      @click="showModalFollow(data.item)"
                      >ثبت پیگیری</b-btn
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-pagination
                v-model="currentPageNewOrder"
                :total-rows="
                  computedOrders(
                    items
                      .filter((x) => x.code != '-')
                      .filter((x) => x.factoryStatus == status.value),
                    'allOrders'
                  ).length
                "
                :per-page="perPage"
                aria-controls="allOrders-tabel"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
            </b-card>
          </b-tab>
          <b-tab
            v-if="items.filter((x) => x.code == '-').length"
            :title="
              'بدون کد ردیابی' +
              ' (' +
              items.filter((x) => x.code == '-').length +
              ')'
            "
          >
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                class="darkGreen-mainBtn mb-4 float-start"
                :class="
                  computedOrders(
                    items.filter((x) => x.code == '-'),
                    'allOrders'
                  ).length
                    ? 'white--text'
                    : 'disabled-excel'
                "
                style="width: 135px; height: 35px"
                :data="
                  computedOrders(
                    items.filter((x) => x.code == '-'),
                    'allOrders'
                  )
                "
                :columns="
                  fields
                    .map((y) => {
                      return {
                        label: y.label,
                        field: y.key,
                      };
                    })
                    .filter((x) => x.field != 'index')
                    .filter((x) => x.field != 'operation')
                "
                :file-name="
                  'سفارشات_' +
                  moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
                "
                :sheet-name="'سفارشات'"
              >
                <v-icon
                  class="me-1"
                  :class="
                    computedOrders(
                      items.filter((x) => x.code == '-'),
                      'allOrders'
                    ).length
                      ? 'white--text'
                      : ''
                  "
                >
                  mdi-file-excel-outline
                </v-icon>
                خروجی اکسل</vue-excel-xlsx
              >

              <v-btn
                :disabled="
                  gettingReceipt || !computedOrders(items, 'allOrders').length
                "
                class="darkRed-mainBtn white--text float-end mb-4"
                style="width: 135px; height: 35px;"
                @click="printReceipt('withoutCode', 'بدون کد ردیابی')"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
              <b-table
                responsive
                show-empty
                :items="
                  computedOrders(
                    items.filter((x) => x.code == '-'),
                    'allOrders'
                  )
                "
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :busy="isBusy"
                :current-page="currentPageWithoutCode"
                :per-page="perPage"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index' && field.key != 'operation'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="currentPageWithoutCode = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'index'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="
                        toFilterData['allOrders'] = [];
                        currentPageWithoutCode = 1;
                      "
                      >بازنشانی
                    </b-button>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(code)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a :href="'/factory/order/' + data.item.id" target="_blank">
                      {{ data.value }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(progress)="data">
                  <v-progress-circular
                    :rotate="270"
                    :size="40"
                    :width="3"
                    :value="data.item.progress"
                    color="teal"
                  >
                    {{ data.item.progress }}%
                  </v-progress-circular>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.index + 1 + perPage * (currentPageWithoutCode - 1)
                    }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="btn btn-primary mr-1 mt-1"
                      :href="'/factory/order/' + data.item.id"
                      target="_blank"
                      role="button"
                      >جزییات</a
                    >
                    <b-btn
                      variant="warning"
                      class="mr-1 mt-1"
                      v-if="data.item.status != 'آرشیو'"
                      @click="showModalFollow(data.item)"
                      >ثبت پیگیری</b-btn
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>

              <b-pagination
                v-model="currentPageWithoutCode"
                :total-rows="
                  computedOrders(
                    items.filter((x) => x.code == '-'),
                    'allOrders'
                  ).length
                "
                :per-page="perPage"
                aria-controls="allOrders-tabel"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
            </b-card>
          </b-tab>
        </b-tabs>
      </div>

      <br />
    </b-card>

    <b-modal
      id="modalFollow"
      ref="modalFollow"
      header-bg-variant="secondary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>توضیحات برای پرونده استعلام {{ currentOrder.code }}</h4>
      </template>
      <template v-slot:modal-footer>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <b-button
              variant="success"
              size="lg"
              class="ml-2"
              @click="updateOrder()"
              >ثبت توضیحات</b-button
            >
            <b-button
              variant="danger"
              size="lg"
              class="ml-2"
              @click="closeModalّFollow()"
              >بستن</b-button
            >
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </template>
      <b-card style="border: 0" class="mb-0">
        <b-card>
          <p>
            همکار گرامی لطفا توضیحات پیگیری خود و همچنین فایل مربوطه را (در صورت
            وجود) وارد کنید:
          </p>
          <p>توضیحات:</p>
          <div class="item-ckeditor">
            <ckeditor
              v-model="content"
             :editor="editor"
                  :config="editorConfig"
              @blur="onBlur($event)"
              @focus="onFocus($event)"
              @contentDom="onContentDom($event)"
              @dialogDefinition="onDialogDefinition($event)"
              @fileUploadRequest="onFileUploadRequest($event)"
              @fileUploadResponse="onFileUploadResponse($event)"
            />
          </div>
          <hr />
          <b-form-group label="بارگذاری فایل:" label-for="indexPic">
            <b-form-file
              id="indexPic"
              :state="Boolean(file)"
              v-model="file"
              browse-text="آپلود"
              placeholder="فایل مربوطه را آپلود کنید"
              accept="*"
            ></b-form-file>
          </b-form-group>
          <b-form-group>
            <v-col>
              <v-row>
                <b-button
                  :disabled="!file || uploadButDisable"
                  variant="primary"
                  >آپلود داکیومنت</b-button
                >
              </v-row>
              <br />
              <b-progress
                v-if="showProgress"
                :value="uploadPercentage"
                :max="max"
                show-progress
                :animated="striped"
                :variant="variant"
              ></b-progress>
              <v-row>
                <br />
                <div v-if="isUploaded" color="green">
                  فایل با موفقیت آپلود شد.
                </div>
              </v-row>
            </v-col>
          </b-form-group>
        </b-card>
      </b-card>
    </b-modal>
    <div :id="tableType" v-show="false">
      <h3 class="text-right" style="float: right">{{ selectedStatus }}</h3>
      <b-table :items="computedTableItems" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      printInvoice: {},
      gettingReceipt: false,
      tableType: "",
      selectedStatus: "",
      guide: false,
      factory: new Object({
        code: "",
        dueDate: "",
      }),
      moment: moment,
      rejectReason: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      currentOrder: {},
      items: [],
      filter: null,
      fields: [
        { key: "index", label: "#" },
        { key: "code", label: "کد ردیابی" },
        { key: "requestId", label: "شماره درخواست مشتری" },
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "customerName", label: "نام مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "factoryDate", label: "تاریخ ابلاغ" },
        { key: "factoryStatus", label: "وضعیت" },
        { key: "priority", label: "اولویت تولید" },
        { key: "progress", label: "پیشرفت" },
        // { key: "operation", label: "عملیات" },
      ],
      ExcelFields: [
        { field: "code", label: "کد ردیابی" },
        { field: "requestId", label: "شماره درخواست مشتری" },
        { field: "customerName", label: "نام مشتری" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "factoryDate", label: "تاریخ ابلاغ" },
        { field: "factoryStatus", label: "وضعیت" },
        { field: "priority", label: "اولویت تولید" },
        { field: "progress", label: "پیشرفت" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد ردیابی" },
        { key: "requestId", label: "شماره درخواست مشتری" },
        { key: "customerName", label: "نام مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "factoryDate", label: "تاریخ ابلاغ" },
        { key: "factoryStatus", label: "وضعیت" },
        { key: "priority", label: "اولویت تولید" },
      ],

      statusOptions: [
        { value: "سفارش جدید", text: "سفارش جدید" },
        { value: "در مرحله تولید", text: "در مرحله تولید" },
        { value: "در مرحله پوشش کاری", text: "در مرحله پوشش کاری" },
        { value: "در مرحله بسته بندی", text: "در مرحله بسته بندی" },
        { value: "در مرحله ارسال", text: "در مرحله ارسال" },
        // { value: "تحویل و ارسال شد", text: "تحویل و ارسال شد" },
        // { value: "توقف تولید", text: "توقف تولید" },
      ],
      currentPage: 1,
      currentPageNewOrder: 1,
      currentPageWithoutCode: 1,
      perPage: 10,
      isBusy: false,
      totalRows: "",
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },

      role: "",
      toFilterData: {
        allOrders: [],
      },
    };
  },
  computed: {
    computedTableItems() {
      if (this.tableType == "allOrders") {
        return this.computedOrders(this.items, "allOrders");
      } else if (this.tableType == "tabs") {
        return this.computedOrders(
          this.items
            .filter((x) => x.code != "-")
            .filter((x) => x.factoryStatus == this.selectedStatus),
          "allOrders"
        );
      } else if (this.tableType == "withoutCode") {
        return this.computedOrders(
          this.items.filter((x) => x.code == "-"),
          "allOrders"
        );
      }
    },
  },
  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getall",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt(type, item) {
      this.tableType = type;
      this.selectedStatus = item;
      //printing receipt
      var myWindow = window.open("#", this.tableType, "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById(this.tableType).innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    getTableInfo() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orders/actives",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.items = res.data;
            this.totalRows = this.items.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.$refs["modalFollow"].show();
    },
    closeModalّFollow() {
      this.currentOrder = {};
      this.$refs["modalFollow"].hide();
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    updateOrder() {
      // let baseId = this.currentOrder.totalOrder.custom_fields.filter(
      //   x => x.id == 158
      // )[0].value;
      // let currentId = this.currentOrder.taskId;
      // Axios.put(
      //   this.baseUrl + "/issues/" + currentId + ".json",
      //   {
      //     issue: {
      //       uploads: [
      //         {
      //           token: this.mediaToken,
      //           filename: this.file.name,
      //           content_type: this.file.type
      //         }
      //       ],
      //       notes: this.content || ""
      //     }
      //   },
      //   {
      //     headers: {
      //       "X-Redmine-API-Key": window.localStorage.api_key
      //     }
      //   }
      // )
      //   .then(
      //     alert("پرونده با موفقیت به روز شد"),
      //     (this.content = ""),
      //     (this.file = ""),
      //     this.closeModalّFollow()
      //   )
      //   .catch(err2 => {
      //     console.log(err2);
      //   });
    },
    priceSent() {
      // Axios.put(
      //   this.baseUrl + "/issues/" + this.currentOrder.taskId + ".json",
      //   {
      //     issue: {
      //       custom_fields: [
      //         {
      //           id: 159,
      //           value: this.sendMethod
      //         },
      //         { id: 162, value: "در انتظار نظر مشتری" }
      //       ],
      //       uploads: [
      //         {
      //           token: this.mediaToken,
      //           filename: this.file.name,
      //           content_type: this.file.type
      //         }
      //       ],
      //       notes: "پرونده برای مشتری ارسال شد. " + this.content || ""
      //     }
      //   },
      //   {
      //     headers: {
      //       "X-Redmine-API-Key": window.localStorage.api_key
      //     }
      //   }
      // )
      //   .then(
      //     alert("ارسال تعیین قیمت ثبت شد"),
      //     (this.content = ""),
      //     (this.file = ""),
      //     this.closeModalّFollowPrice(),
      //     this.getTableInfo()
      //   )
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    computedOrders(orders, status) {
      let myAllOrders = orders;
      if (myAllOrders.length) {
        try {
          myAllOrders = myAllOrders.filter((item) => {
            return Object.keys(this.toFilterData[status]).every((key) =>
              String(item[key])
                .toLowerCase()
                .includes(this.toFilterData[status][key].toLowerCase())
            );
          });
        } catch (error) {
          console.log(error);
          myAllOrders = [];
        }
      }

      return myAllOrders;
    },
  },

  mounted() {
    this.getTableInfo();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.progress {
  background-color: #222222 !important;
  padding-block-start: 20 px;
}
</style>
